import MomentUtils from "@date-io/moment";
import {
	KeyboardDatePicker,
	MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import React from "react";

type Props = {
	date: Date;
	setDate: (date: Date) => void;
	label: string | undefined;
};

export const DateFilter = ({ date, setDate, label = "Date" }: Props) => {
	const handleDateChange = (datePicker: MaterialUiPickersDate) => {
		setDate(datePicker!.toDate());
	};

	return (
		<MuiPickersUtilsProvider utils={MomentUtils}>
			<KeyboardDatePicker
				disableToolbar
				variant="inline"
				format="MM/DD/yyyy"
				id="date-picker-inline"
				style={{
					minWidth: "100%",
					borderTopLeftRadius: 3,
					borderTopRightRadius: 3,
				}}
				label={label}
				value={date}
				onChange={handleDateChange}
				KeyboardButtonProps={{
					"aria-label": "change date",
				}}
			/>
		</MuiPickersUtilsProvider>
	);
};
